import React, { useMemo } from 'react';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';
import { FormSelect } from '@getro/rombo';
import { useGetSharedListsQuery } from 'services/contacts';
import { FormikAutoSubmit } from '../../../../components/atoms/formikAutoSubmit';

export const MovementSharedListFilter = ({ value, setFilters }) => {
  const { data } = useGetSharedListsQuery({ kind: 'people' });

  const options = useMemo(() => {
    const lists = data?.sharedLists || data?.items || [];
    return lists.map((list) => ({
      value: list.id,
      label: list.name || list.attributes?.name || '',
    }));
  }, [data]);

  const onSubmit = ({ sharedListIds }) => {
    setFilters({ sharedListIds: sharedListIds || [] });
  };

  return (
    <Formik initialValues={{ sharedListIds: value || [] }} onSubmit={onSubmit} enableReinitialize>
      <Form>
        <FormikAutoSubmit />
        <Field
          name="sharedListIds"
          label="Shared lists"
          placeholder="All"
          component={FormSelect}
          options={options}
          multiple
          size="small"
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

MovementSharedListFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

MovementSharedListFilter.defaultProps = {
  value: [],
};
